﻿import MatterPage from "./gmMatterPage";
import GMCostTrackingPage from "./gmCostTrackingPage";
import GMActionDuePage from "./gmActionDuePage";
import GMGlobalUpdate from "./gmGlobalUpdate";


if (!window.gmMatterPage) {
    window.gmMatterPage = new MatterPage();
}

if (!window.gmCostTrackingPage) {
    window.gmCostTrackingPage = new GMCostTrackingPage();
}

if (!window.gmActionDuePage) {
    window.gmActionDuePage = new GMActionDuePage();
}

if (!window.gmGlobalUpdate) {
    window.gmGlobalUpdate = new GMGlobalUpdate();
}

